var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsLightMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42555 19.6401C4.96555 19.6401 4.58155 19.4861 4.27355 19.1781C3.96488 18.8695 3.81055 18.4851 3.81055 18.0251V7.25514C3.81055 6.79514 3.96488 6.41114 4.27355 6.10314C4.58155 5.79447 4.96555 5.64014 5.42555 5.64014H20.1955C20.6555 5.64014 21.0395 5.79447 21.3475 6.10314C21.6562 6.41114 21.8105 6.79514 21.8105 7.25514V18.0251C21.8105 18.4851 21.6565 18.8691 21.3485 19.1771C21.0399 19.4858 20.6555 19.6401 20.1955 19.6401H5.42555ZM12.8105 12.7551L20.8105 7.52514L20.5025 6.64014L12.8105 11.6401L5.11855 6.64014L4.81055 7.52514L12.8105 12.7551Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsLightMail);
export default __webpack_public_path__ + "static/media/material-symbols-light_mail.7dd071cdf8af454bc89f7b0cc51e631f.svg";
export { ForwardRef as ReactComponent };